import { render, staticRenderFns } from "./vipcard.vue?vue&type=template&id=3f6f4096&scoped=true&"
import script from "./vipcard.vue?vue&type=script&lang=js&"
export * from "./vipcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6f4096",
  null
  
)

export default component.exports